import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { CommonSettingsUnionKeys, PaymentMethodSetting, PaymentMethodSettingsResponse } from '../entities';
import { CommonSettings } from '../entities/common-settings';

const actionFeatureKey = 'Platform Settings';

export const loadPaymentMethods = createAction(`[${actionFeatureKey}/API] Load payment methods settings`);
export const loadPaymentMethodsSuccess = createAction(
    `[${actionFeatureKey}/API] Load payment methods settings success`,
    props<{ paymentMethods: PaymentMethodSetting[] }>()
);
export const loadPaymentMethodsFailure = createAction(
    `[${actionFeatureKey}/API] Load payment methods settings failure`,
    props<{ error: HttpErrorResponse }>()
);

export const loadCommon = createAction(`[${actionFeatureKey}/API] Load common settings`);
export const loadCommonSuccess = createAction(
    `[${actionFeatureKey}/API] Load common settings success`,
    props<{ common: CommonSettings }>()
);
export const loadCommonFailure = createAction(
    `[${actionFeatureKey}/API] Load common settings failure`,
    props<{ error: HttpErrorResponse }>()
);

export const updatePaymentMethods = createAction(
    `[${actionFeatureKey}/API] Update payment method settings`,
    props<{ paymentMethodSettings: PaymentMethodSetting[] }>()
);
export const updatePaymentMethodsSuccess = createAction(
    `[${actionFeatureKey}/API] Update payment method settings success`,
    props<{ paymentMethods: PaymentMethodSetting[] }>()
);
export const updatePaymentMethodsFailure = createAction(
    `[${actionFeatureKey}/API] Update payment method settings failure`,
    props<{ error: HttpErrorResponse }>()
);

export const updateCommon = createAction(
    `[${actionFeatureKey}/API] Update common settings`,
    props<{ commonSettings: CommonSettingsUnionKeys }>()
);
export const updateCommonSuccess = createAction(
    `[${actionFeatureKey}/API] Update common settings success`,
    props<{ commonSettings: CommonSettings }>()
);
export const updateCommonFailure = createAction(
    `[${actionFeatureKey}/API] Update common settings failure`,
    props<{ error: HttpErrorResponse }>()
);
